import React, { useState } from "react";
import LegalModal from "./LegalModal";

export default function Footer() {
  const [showLegalModal, setShowLegalModal] = useState(false);
  const [legalModalType, setLegalModalType] = useState(null);
  const [showSupportModal, setShowSupportModal] = useState(false);

  const openLegalModal = (type) => {
    setLegalModalType(type);
    setShowLegalModal(true);
  };

  return (
    <>
      <footer className="bg-slate-800 text-slate-300 py-6 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Left Side - App Info */}
            <div className="text-center md:text-left">
              <p className="text-sm font-medium text-slate-200">
                BurningTeam
              </p>
              <p className="text-xs text-slate-400 mt-1">
                Organisationshilfe mit Zielplanungskalender &amp; Warenverwaltung
              </p>
            </div>

            {/* Center - Legal Links */}
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <button
                onClick={() => openLegalModal('impressum')}
                className="text-slate-300 hover:text-white transition-colors underline"
              >
                Impressum
              </button>
              <span className="text-slate-600">|</span>
              <button
                onClick={() => openLegalModal('privacy')}
                className="text-slate-300 hover:text-white transition-colors underline"
              >
                Datenschutz
              </button>
              <span className="text-slate-600">|</span>
              <button
                onClick={() => openLegalModal('nutzungsbedingungen')}
                className="text-slate-300 hover:text-white transition-colors underline"
              >
                Nutzungsbedingungen
              </button>
              <span className="text-slate-600">|</span>
              <button
                onClick={() => openLegalModal('terms')}
                className="text-slate-300 hover:text-white transition-colors underline"
              >
                Haftungsausschluss
              </button>
              <span className="text-slate-600">|</span>
              <button
                onClick={() => setShowSupportModal(true)}
                className="text-slate-300 hover:text-white transition-colors underline"
              >
                Support / Bug Report
              </button>
            </div>

            {/* Right Side - Copyright */}
            <div className="text-center md:text-right text-xs text-slate-400">
              <p>© {new Date().getFullYear()} Alle Rechte vorbehalten</p>
              <p className="mt-1">Organisationstool</p>
            </div>
          </div>

          {/* Bottom Disclaimer */}
          <div className="mt-4 pt-4 border-t border-slate-700 flex flex-col sm:flex-row items-center justify-between gap-2 text-center">
            <p className="text-xs text-slate-500">
              Diese App wird privat entwickelt und bereitgestellt. Alle Angaben erfolgen ohne Gewähr.
            </p>
            <a
              href="https://app.emergent.sh/?utm_source=emergent-badge"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-300 transition-colors whitespace-nowrap"
            >
              <img
                src="https://avatars.githubusercontent.com/in/1201222?s=40"
                alt="Emergent"
                className="w-4 h-4 rounded-full"
              />
              Made with Emergent
            </a>
          </div>
        </div>
      </footer>

      <LegalModal
        isOpen={showLegalModal}
        onClose={() => setShowLegalModal(false)}
        type={legalModalType}
      />

      {/* Support Modal */}
      {showSupportModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
            {/* Header */}
            <div className="flex justify-between items-center p-6 border-b border-slate-200">
              <h2 className="text-xl font-bold text-slate-900">Support & Bug Report</h2>
              <button
                onClick={() => setShowSupportModal(false)}
                className="text-slate-400 hover:text-slate-600 text-2xl font-bold leading-none"
              >
                ×
              </button>
            </div>

            {/* Content */}
            <div className="p-6">
              <div className="space-y-4 text-sm text-slate-700">
                <p>
                  Haben Sie Fragen zur App oder sind Ihnen Fehler (Bugs) aufgefallen?
                </p>
                <p>
                  Wir sind jederzeit für Sie da! Senden Sie uns gerne eine E-Mail an:
                </p>
                <div className="flex justify-center my-4">
                  <a
                    href="mailto:Support@burningteam.de"
                    className="inline-flex items-center px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-medium transition-colors"
                  >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    Support@burningteam.de
                  </a>
                </div>
                <p className="text-xs text-slate-500 text-center">
                  Wir bemühen uns, Ihre Anfragen schnellstmöglich zu bearbeiten.
                </p>
              </div>
            </div>

            {/* Footer */}
            <div className="p-6 border-t border-slate-200 bg-slate-50">
              <button
                onClick={() => setShowSupportModal(false)}
                className="w-full px-4 py-2 bg-slate-600 hover:bg-slate-700 text-white rounded-lg font-medium transition-colors"
              >
                Schließen
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
